import Slope from "../../assets/logos/slope.svg";
import Mashable from "../../assets/logos/mashable.svg";
import Coindesk from "../../assets/logos/coindesk.svg";

export const FeaturedPress: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full py-12 bg-coinage-offWhite ">
      <svg
        className="w-[48px] mb-6"
        viewBox="0 0 51 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.96"
          d="M16.75 0L21.625 10C14.75 12.125 13.125 14.875 13.125 20.25V20.5H22.25V44H0V22C0 11.125 4.875 3.5 16.75 0ZM45.375 0L50.25 10C43.375 12.125 41.875 14.875 41.875 20.25V20.5H51V44H28.75V22C28.75 11.125 33.625 3.5 45.375 0Z"
          fill="#FF4517"
        />
      </svg>
      <h3 className="text-coinage-black display3 text-center max-w-[35ch] px-2 md:px-4">
        Crypto&apos;s innovative, entertaining and first community-owned media
        outlet
      </h3>
      <div className="flex items-center flex-col gap-4 mt-2">
        <span className="text-center text-coinage-orange subhead2">
          Featured In:
        </span>
        <div className="flex lg:gap-12 md:gap-10 gap-4 items-center">
          <a
            href="https://www.linkedin.com/pulse/telling-story-web3-crypto-karine-hsu/?trackingId=bA1XbZjqR7y%2F2hbQoTixag%3D%3D"
            target="_blank"
            rel="noreferrer">
            <Slope className="mt-2 h-[20px] md:h-[28px]" />
          </a>
          <a
            href="https://nl.mashable.com/entertainment/8905/when-creativity-meets-crypto-interview-with-netflix-co-founder-and-founding-ceo-marc-randolph-and-tr"
            target="_blank"
            rel="noreferrer">
            <Mashable className="h-[20px] md:h-[28px]" />
          </a>
          <a
            href="https://www.coindesk.com/learn/decentralized-media-is-breaking-barriers-in-a-web2-world/"
            target="_blank"
            rel="noreferrer">
            <Coindesk className="h-[20px] md:h-[28px]" />
          </a>
        </div>
      </div>
    </div>
  );
};
